<template>
  <Layout>
    <Content :style="{'padding': '10px'}">
      <Breadcrumb :style="{margin: '5px 0'}">
        <BreadcrumbItem>通用管理 > <b>标签列表</b></BreadcrumbItem>
      </Breadcrumb>
	  <Card :style="{'padding':'0px 5px','margin-bottom':'5px'}">
	        <span class="search_span_width">
	            <span class="search_span_width_part1">父标签：</span>
				<Select v-model="search.p_tag_id" style="width:260px" clearable>
					<Option v-for="item in p_tag_list" :value="item.id" :key="item.id">{{ item.tag_name }}</Option>
				</Select>
	        </span>
			<span class="search_span_width">
				<span class="search_span_width_part1">类型：</span>
				<Select v-model="search.tag_type" style="width:120px" clearable>
					<Option value="0">默认</Option>
					<Option value="1">行业</Option>
					<Option value="2">PC端</Option>
				</Select>
	        </span>
			<span class="search_span_width">
				<span class="search_span_width_part1">语言：</span>
				<Select v-model="search.lang" style="width:120px" clearable>
					<Option value="zh">中文</Option>
					<Option value="en">英文</Option>
				</Select>
	        </span>
	    <Button type='primary' icon="ios-search" :style="{'margin-left':'20px'}" @click="getTagList()">搜索</Button>
		&nbsp;&nbsp;<Button type='primary' :style="{'margin-left':'5px'}" @click="addModal()">添加父标签</Button>
	  </Card>
      <Card>
       <p :style="{'margin':'5px 10px 10px 20px','clear':'both','overflow':'hidden'}">
			<span :style="{'text-align':'center','float':'left'}">
				<Button type='primary' :style="{'margin-left':'5px'}" @click="addModal(true)">添加子标签</Button>
			</span>
        </p>
        <Card id="tableContent" >
          <Table :columns="tableColumns" :data="tag_list"></Table>
        </Card>
      </Card>
    </Content>
   <Modal v-model="showmodal" :footer-hide=true title="标签">
        <Form ref="tag" :model="tag" :label-width="80" >
			<FormItem label="父级" prop="p_tag_id">
				 <Select v-model="tag.p_tag_id" style="width:260px">
				 	<Option v-for="item in p_tag_list" :value="item.id" :key="item.id">{{ item.tag_name }}</Option>
				 </Select>
			</FormItem>
   			<FormItem label="标签名称" prop="tag_name">
   				 <Input v-model="tag.tag_name"  />
   			</FormItem>
          <FormItem label="语言" prop="tag_name" v-if="tag.p_tag_id>0">
            <Select v-model="tag.lang"  style="width:250px">
              <Option value="zh" >中文</Option>
              <Option value="en" >英文</Option>
            </Select>
          </FormItem>
   			<FormItem label="排序" prop="seq">
   				 <Input v-model="tag.seq" />
   			</FormItem> 
			<FormItem label="类型" prop="tag_type" v-if="tag.p_tag_id==0">
   				<Select v-model="tag.tag_type"  style="width:250px">
					<Option value="0">默认</Option>
					<Option value="1">行业</Option>
				</Select>
			</FormItem>
            <FormItem>
                <Button type="primary" @click="updateTag()">提交</Button>
            </FormItem>
        </Form>
    </Modal>
  </Layout>
</template>
<script>
const OSS = require('ali-oss');
export default {
  data(){
    return {
		search:{
			p_tag_id:0,
      		lang:'',
			tag_type:-1,
		},
		showmodal:false,
		tag_list:[],
		p_tag_list:[],
		tag:{
			id:0,
			tag_name:'',
			p_tag_id:0,
      		lang:'zh',
			seq:0,
			tag_type:0
		},
		tableColumns:[
		{ title: 'ID', key: 'id', align: 'center' },
		{ title: '标签名', key: 'tag_name', align: 'center' },
		{ title: '排序', key: 'seq', align: 'center' },
		{ title: '操作', key: 'action', align: 'center',
		  render: (h, params) => {
			let btns=[]
			btns.push(
				h('Button', {
				  props: { type: 'warning', size: 'small' },
				  style: { marginRight: '5px', marginBottom: '5px'},
				  on: {
					click: () => {      
						this.tag.id = params.row.id;
						this.tag.p_tag_id = params.row.p_tag_id;
						this.tag.tag_name = params.row.tag_name;
            			this.tag.lang = params.row.lang;
						this.tag.seq = params.row.seq;
						this.tag.tag_type = params.row.tag_type;
						this.showmodal = true;
					}
				  }
				}, '编辑'),
			);
			//如果是子级可以删除
			if (params.row.p_tag_id) {
				btns.push(
					h('Button', {
					  props: { type: 'warning', size: 'small' },
					  style: { marginRight: '5px', marginBottom: '5px'},
					  on: {
						click: () => {      
							this.delTag(params.row.id);
						}
					  }
					}, '删除'),
				);
			}
			return h("div",btns);
		  }
		}
		]
	}
  },
  mounted:function(){
    this.getTagList();
	this.getpTagList();
  },
  computed:{

  },
  methods:{
	addModal(p=false){
		this.tag.id = 0;
		if (p == true) {
			if (this.search.p_tag_id == 0) {
				this.$Message.error('请先选择查询父标签');
				return false;
			} 
			this.tag.p_tag_id = this.search.p_tag_id;
		} else {
			this.tag.p_tag_id = 0;
		}
		this.tag.tag_name = '';
		this.seq = 0;
		this.showmodal = true;
	},
	getTagList() {
		this.http.get('/admin/common/tagList',{params:this.search}).then(response=>{
		  let data=response.data;
		  if(data.code!==0){
			alert(data.message);
		  } else{
			this.tag_list = data.data;
		  }
		}).catch(()=>{
		  this.$Message.error('网络错误');
		});
	},
	getpTagList() {
		let p = {'tag_type':-1};
		this.http.get('/admin/common/tagList',{params:p}).then(response=>{
		  let data=response.data;
		  if(data.code!==0){
			alert(data.message);
		  } else{
			this.p_tag_list = data.data;
		  }
		}).catch(()=>{
		  this.$Message.error('网络错误');
		});
	},
	updateTag(){
		this.http.post('/admin/common/upsertTag',{
			id:this.tag.id,
			tag_name:this.tag.tag_name,
			p_tag_id:this.tag.p_tag_id,
			lang:this.tag.lang,
			seq:this.tag.seq,
			tag_type:this.tag.tag_type
		}).then(response=>{
		  let data=response.data;
		  if(data.code!==0) {
		    this.$Message.error(data.message);
		    return false;
		  } else{
		    this.$Message.info(data.message);
		    this.showmodal = false;
			this.getTagList();
		    return true;
		  }
		});
	},
	delTag(id){
		var config = {
			content: '确认删除？删除可能会影响到已使用标签的用户',
			onOk: () => {
				this.http.post('/admin/common/delTag',{id:id}).then(response=>{
				  let data=response.data;
				  if(data.code!==0){
					this.$Message.error(data.message);
				  } else{
					this.getTagList(this.page);
				  }
				}).catch(()=>{
				  this.$Message.error('网络错误');
				});
			}
		}
		this.$Modal.warning(config)
	}
  }

}
</script>
